<template>
  <b-container>
    <Spinner size="32" message="Loading..." style="margin:0,auto" v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-row>
      <b-col>
        <p class="reg-heading-tab mb-3">EMI Schedule</p>
        <b-table
          ref="emiTable"
          show-empty
          head-variant="dark"
          empty-text="No Schedule available."
          stacked="md"
          bordered
          striped
          :items="emiList"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          style="font-size:12px"
        >
          <template v-slot:cell(SL)="row">
            <span aria-hidden="true">{{row.index+1+(10*(currentPage-1))}}</span>
          </template>
          <template v-slot:cell(selected)="row">
            <span v-if="row.item.IsDue">Yes</span>
          </template>
          <template v-slot:custom-foot>
            <b-tr style="background-color:#1a6496;color:#ffffff;font-size:13px;">
              <b-td></b-td>
              <b-td><strong>TOTAL</strong></b-td>
              <b-td><strong>{{ fmtNum(columnTotals.EMIAmount) }}</strong></b-td>
              <b-td></b-td>
              <b-td><strong>{{ fmtNum(columnTotals.PrincipalAmount) }}</strong></b-td>
              <b-td><strong>{{ fmtNum(columnTotals.InterestAmount) }}</strong></b-td>
              <b-td></b-td>
              <b-td></b-td>
            </b-tr>
          </template>
        </b-table>
        <b-row>
          <b-col md="8" class="my-1">
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              size="sm"
            />
          </b-col>
          <b-col md="4" class="my-1">
            <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
              <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import Formatter from "@/Formatter";
export default {
  components: { Spinner },
  props: ["ApplicationID"],
  data() {
    return {
      emiList: [],
      fields: [
        { key: "SL", label: "Sr No" },
        { key: "EMIDate", label: "Month", formatter: "convertDateFormat" },
        { key: "EMIAmount", label: "EMI" },
        { key: "OpeningBalance", label: "Opening Amount" },
        { key: "PrincipalAmount", label: "Principal" },
        { key: "InterestAmount", label: "Interest" },
        { key: "ClosingBalance", label: "Balance" },
        { key: "selected", label: "Due Claim" }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50, 100],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false
    };
  },
  computed: {
    columnTotals() {
      return this.emiList.reduce((acc, row) => {
        acc.EMIAmount = (acc.EMIAmount || 0) + (Number(row.EMIAmount) || 0);
        acc.PrincipalAmount = (acc.PrincipalAmount || 0) + (Number(row.PrincipalAmount) || 0);
        acc.InterestAmount = (acc.InterestAmount || 0) + (Number(row.InterestAmount) || 0);
        return acc;
      }, {});
    }
  },
  watch: {
    ApplicationID: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getEMIList();
      }
    }
  },
  methods: {
    fmtNum(val) {
      return (Number(val) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    getEMIList() {
      let promise = apis.getSehedule(this.ApplicationID);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.emiList = response.body;
            this.totalRows = this.emiList.length;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/ClaimComponents/EMISchedule.vue